import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Navigate } from 'react-router-dom';

// Import all dashboard components
import AdminDashboard from './Dashboard';
import ManagerDashboard from './carehome_manager/Dashboard';
import StaffDashboard from './staffs/dashbaord';

/**
 * Common Dashboard Router
 * Routes to the appropriate dashboard based on user role
 * This is the unified entry point for all users accessing /dashboard
 */
const CommonDashboard = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );


    
  }

  const roleCode = user?.role?.role_code;

  // Route based on user role
  if (roleCode === 'admin' || roleCode === 'super_admin') {
    return <AdminDashboard />;
  } else if (['carehome_manager', 'carehome_owner', 'domiciliary_owner'].includes(roleCode)) {
    return <ManagerDashboard />;
  } else if (roleCode === 'staffs') {
    return <ManagerDashboard />;
  }

  // Fallback to admin dashboard if role doesn't match
  return <AdminDashboard />;
};

export default CommonDashboard;
